export default [
  // {
  //   name: "12 месяцев",
  //   options: [
  //     // "60 дней заморозки",
  //     "1 тренировка с тренером",
  //     "2 гостевых флаера",
  //     "Анализ состава тела аппаратом Танита",
  //     "Пользование приложением MWC",
  //     "Участие во внутриклубных марафонах",
  //     "Большая линейка групповых программ",
  //     "Безлимитное посещение всех зон клуба",
  //     "Месяц в подарок",
  //   ],
  // },
  // {
  //   name: "9 месяцев",
  //   options: [
  //     "1 тренировка с тренером",
  //     "2 гостевых флаера",
  //     "Анализ состава тела аппаратом Танита",
  //     "Пользование приложением MWC",
  //     "Участие во внутриклубных марафонах",
  //     "Большая линейка групповых программ",
  //     "Безлимитное посещение всех зон клуба",
  //   ],
  // },
  {
    name: "6 месяцев",
    options: [
      "1 тренировка с тренером",
      "2 гостевых флаера",
      "Анализ состава тела аппаратом Танита",
      "Пользование приложением MWC",
      "Участие во внутриклубных марафонах",
      "Большая линейка групповых программ",
      "Безлимитное посещение всех зон клуба",
    ],
  },
  {
    name: "3 месяца",
    options: [
      "1 тренировка с тренером",
      "2 гостевых флаера",
      "Анализ состава тела аппаратом Танита",
      "Пользование приложением MWC",
      "Участие во внутриклубных марафонах",
      "Большая линейка групповых программ",
      "Безлимитное посещение всех зон клуба",
    ],
  },
];
